import React, { useContext, useRef } from 'react';
import './home.scss';
import ComuneSelector from '../../components/comuneSelector/ComuneSelector';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import TenantEditPanel, { TenantEditPanelHandle } from '../../components/tenantEdit/TenantEditPanel';
import TenantContext from '../../contexts/tenantContext';
import TenantEditContattiPanel from '../../components/tenantEdit/TenantEditContattiPanel';

export default function Home() {
  const { currentTenant } = useContext(TenantContext);
  const tenantEditPanelRef = useRef<TenantEditPanelHandle>(null);

  async function Save() {
    if (await tenantEditPanelRef.current?.save()) {

    }
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Comune</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          <TenantEditPanel ref={tenantEditPanelRef} tenantId={currentTenant.Id}></TenantEditPanel>
          <Toolbar>
            <Item
              widget="dxButton"
              location="after"
              options={{
                text: 'Salva',
                type: 'default',
                stylingMode: 'contained',
                onClick: Save
              }}
            />
          </Toolbar>

          <TenantEditContattiPanel tenantId={currentTenant.Id} />
        </div>
      </div>
    </React.Fragment>
  )
}
